import React from 'react';
import styled from '@emotion/styled';
import type { WPublicWeddingView } from '@zola/svc-web-api-ts-client';
import HashtagModule from './HashtagModule';
import LocationDateModule from './LocationDateModule';

const WeddingInfoSection = ({
  className,
  wedding,
}: {
  wedding?: WPublicWeddingView;
  className?: string;
}): JSX.Element => {
  const { hashtag } = wedding || {};

  const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    > div {
      justify-content: center;
      text-align: center;
    }
  `;

  const StyledHashtagModule = styled(HashtagModule)`
    padding-top: 120px;
    padding-bottom: 40px;
  `;

  return (
    <Container className={className}>
      <StyledHashtagModule hashtag={hashtag} />
      <LocationDateModule wedding={wedding} />
    </Container>
  );
};

export default WeddingInfoSection;
